export default __webpack_public_path__ + "static/media/avatarofxotli.5744c5e7.png";